// images
import mainInterior from "../assets/mainPage/mainInterior.webp";
import vybiraempotolok1 from "../assets/otherPages/interior/vybiraem_potolok_1.webp";
import vybiraempotolok2 from "../assets/otherPages/interior/vybiraem_potolok_2.webp";
import vybiraempotolok3 from "../assets/otherPages/interior/vybiraem_potolok_3.webp";

import mainInteriorSidebar1 from "../assets/mainPage/mainInteriorSidebar1.webp";
import mainInteriorSidebar2 from "../assets/mainPage/mainInteriorSidebar2.webp";
import mainInteriorSidebar3 from "../assets/mainPage/mainInteriorSidebar3.webp";

import oboi1 from "../assets/otherPages/interior/21_bumajnye.webp";
import oboi2 from "../assets/otherPages/interior/22_vinilovye.webp";
import oboi3 from "../assets/otherPages/interior/23_tekstil.webp";
import oboi4 from "../assets/otherPages/interior/24_foto.webp";
import oboi5 from "../assets/otherPages/interior/25_jidkie.webp";
import oboi6 from "../assets/otherPages/interior/26_flizel.webp";
import oboi7 from "../assets/otherPages/interior/27_steklo.webp";
import oboi8 from "../assets/otherPages/interior/28_natural.webp";
import oboi9 from "../assets/otherPages/interior/29_metall.webp";

import vybiraemmezhkom1 from "../assets/otherPages/interior/vybiraem_mezhkom_1.webp";
import vybiraemmezhkom2 from "../assets/otherPages/interior/vybiraem_mezhkom_2.webp";

import vinilovayaplitka1 from "../assets/otherPages/interior/vinilovaya_1.webp";
import vinilovayaplitka2 from "../assets/otherPages/interior/vinilovaya_2.webp";
import vinilovayaplitka3 from "../assets/otherPages/interior/vinilovaya_3.webp";

import regulirovkaOkon1 from "../assets/otherPages/interior/regulirovka_okon1.webp";
import regulirovkaOkon2 from "../assets/otherPages/interior/regulirovka_okon2.webp";
import regulirovkaOkon3 from "../assets/otherPages/interior/regulirovka_okon3.webp";

// interior articles
export const interiorArticles = [
  // ARTICLE 1 START
  {
    id: "Выбираем потолок",
    img: mainInterior,
    pretitle: "Интерьер",
    title: "Выбираем потолок",
    tagString: "интерьер потолок потолки подвесной",
    tags: [
      {
        tag: "интерьер",
        tagLink: "#",
      },
      {
        tag: "потолок",
        tagLink: "#",
      },
      {
        tag: "потолки",
        tagLink: "#",
      },
      {
        tag: "подвесной",
        tagLink: "#",
      },
    ],
    linkToArticle: "/interior/Выбираем потолок",
    text: [
      {
        attribute: "paragraph",
        content:
          "Решили установить подвесной потолок? Но не можете определить какой именно выбрать? Тогда эта статья специально для вас. В ней вы узнаете ответы на основные вопросы:",
      },
      {
        attribute: "list",
        content: [
          { item: "типы подвесных потолков" },
          { item: "материалы изготовления" },
        ],
      },
      {
        attribute: "image",
        content: vybiraempotolok1,
      },
      {
        attribute: "title",
        content: "Модульные потолки",
      },
      {
        attribute: "paragraph",
        content:
          "Представляют из себя подвесную систему с установленными на неё модулями разнообразной формы: рейки, плитки, кассеты(т.н. растровые). Модульные конструкции отличаются высокой звукоизоляцией и экологичностью. Позволяют создавать различные узоры и применять всевозможные цветовые решения. Благодаря малому весу и простоте монтажа, не требуют специальных навыков для установки. Также к преимуществам следует отнести возможность частичной замены, в случае порчи, одного или нескольких элементов конструкции.",
      },
      {
        attribute: "paragraph",
        content:
          "Плиточные потолки производят из пластмассы, гипса, пенополистирола, либо минеральных волокон. Помимо стандартных, размером 60х60см, также выпускают криволинейные плиты, применяемые в создании трёхмерных и многоуровневых потолков.",
      },
      {
        attribute: "paragraph",
        content:
          "Реечные потолки представляют собой алюминиевые рейки прикреплённые к металлическому каркасу. Благодаря повышенной влагостойкости, подходят для установки в ванной и на кухне.",
      },
      {
        attribute: "paragraph",
        content:
          "Кассетные(растровые) потолки сочетают высокую функциональность с простотой форм. Производятся из оцинкованной стали или алюминия.",
      },
      {
        attribute: "image",
        content: vybiraempotolok2,
      },
      {
        attribute: "title",
        content: "Натяжные потолки",
      },
      {
        attribute: "paragraph",
        content:
          "Обладают высокой долговечностью, экологичностью, влагостойкостью и большим выбором цветов и фактур. Натяжное полотно изготовленное из ПВХ, не горит и не образует конденсат. Монтаж не требует особых усилий: на установленную рамку натягивается полотно. Однако в процессе установки, следует помнить, что плёнка легко протыкается и устранить этот дефект в дальнейшем будет невозможно.",
      },
      {
        attribute: "image",
        content: vybiraempotolok3,
      },
      {
        attribute: "title",
        content: "Потолки из гипсокартона",
      },
      {
        attribute: "paragraph",
        content:
          "Гипсокартон позволяет создавать следующие формы: ступенчатые, криволинейные и ломаные. Монтаж производится на деревянные бруски или металлический профиль. Такой тип потолка позволяет установить практически любой вид освещения, а также звуковую и теплоизоляцию. К недостаткам стоит отнести снижение высоты помещения.",
      },
      {
        attribute: "paragraph",
        content:
          "Подводим итог. Модульные потолки подойдут большим помещениям: гостиницам, банкам, магазинам и т.д. Для помещений с невысокими потолками оптимальным выбором станут натяжные конструкции. Выбор за вами!",
      },
    ],
  },
  // ARTICLE 1 END

  // ARTICLE 2 START
  {
    id: "Инструкция по выбору обоев",
    img: mainInteriorSidebar1,
    pretitle: "Интерьер",
    title: "Инструкция по выбору обоев",
    tagString: "интерьер обои отделка стены",
    tags: [
      {
        tag: "интерьер",
        tagLink: "#",
      },
      {
        tag: "обои",
        tagLink: "#",
      },
      {
        tag: "отделка",
        tagLink: "#",
      },
      {
        tag: "стены",
        tagLink: "#",
      },
    ],
    linkToArticle: "/interior/Инструкция по выбору обоев",
    text: [
      {
        attribute: "paragraph",
        content:
          "Самый популярный и распространенный материал для отделки стен — обои. Для правильного выбора, необходимо знать основные характеристики различных типов обое",
      },
      {
        attribute: "paragraph",
        content: "Самые распространенные виды обоев:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "бумажные",
          },
          {
            item: "виниловые",
          },
          {
            item: "текстильные",
          },
          {
            item: "фотообои",
          },
          {
            item: "жидкие обои",
          },
          {
            item: "флизелиновые",
          },
          {
            item: "стеклообои",
          },
          {
            item: "из натуральных материалов",
          },
          {
            item: "металлизированные",
          },
        ],
      },
      {
        attribute: "image",
        content: oboi1,
      },
      {
        attribute: "paragraph",
        content:
          "Бумажные обои — доступные, экологичные, могут быть рельефными и гладкими, с различными вариантами рисунка, их можно красить и покрывать водоотталкивающими средствами. Недостатки — недолговечность, невозможность мытья.",
      },
      {
        attribute: "image",
        content: oboi2,
      },
      {
        attribute: "paragraph",
        content:
          "Виниловые обои подойдут для любых помещений, кроме спален и детских, из-за содержания химических веществ. Они легко моются и имеют долгий срок службы.",
      },
      {
        attribute: "image",
        content: oboi3,
      },
      {
        attribute: "paragraph",
        content:
          "Текстильные обои представляют собой два слоя — бумага и наклеенный на нее текстильный материал - либо натуральный(шелк, лен, хлопок и т. п.), либо синтетический, либо смешанный. Такие обои обладают звуко- и теплоизоляционными свойствами, позволяют стенам дышать.",
      },
      {
        attribute: "image",
        content: oboi4,
      },
      {
        attribute: "paragraph",
        content:
          "Фотообои расширяют пространство и создают определенную атмосферу. Обладают теми же свойствами, что и бумажные обои.",
      },
      {
        attribute: "image",
        content: oboi5,
      },
      {
        attribute: "paragraph",
        content:
          "Жидкие обои наносятся на ровные стены краскораспылителем или вручную, с помощью валика. Можно создать как гладкую, так и рельефную поверхность без швов. В состав входят различные текстильные волокна, которые разводятся водоэмульсионной краской.",
      },
      {
        attribute: "image",
        content: oboi6,
      },
      {
        attribute: "paragraph",
        content:
          "Флизелиновые обои состоят из целлюлозы и синтетических тканевых волокон. Они отлично скрывают неровности стен и подходят для окрашивания.",
      },
      {
        attribute: "image",
        content: oboi7,
      },
      {
        attribute: "paragraph",
        content:
          "Стеклообои производят из стекловолокна — негорючего, экологичного и износостойкого материала. Возможно применение в самых различных местах — в жилых и нежилых помещениях. Имеют разнообразную фактуру. Служат до 30 лет.",
      },
      {
        attribute: "image",
        content: oboi8,
      },
      {
        attribute: "paragraph",
        content:
          "Обои из натуральных материалов изготавливают путем нанесения на бумажную основу тонкого слоя природных волокон таких как бамбук, пробка, листья магнолии, шпон сандалового дерева и т. д.",
      },
      {
        attribute: "image",
        content: oboi9,
      },
      {
        attribute: "paragraph",
        content:
          "Металлизированные обои — на бумажную основу наносится алюминиевая фольга.",
      },
      {
        attribute: "paragraph",
        content:
          "Большой ассортимент позволяет подобрать обои на любой вкус и для решения различных задач.",
      },
    ],
  },
  // ARTICLE 2 END

  // ARTICLE 3 START
  {
    id: "Выбираем межкомнатные двери",
    img: mainInteriorSidebar2,
    pretitle: "Интерьер",
    title: "Выбираем межкомнатные двери",
    tagString: "интерьер дверь двери межкомнатные",
    tags: [
      {
        tag: "интерьер",
        tagLink: "#",
      },
      {
        tag: "дверь",
        tagLink: "#",
      },
      {
        tag: "двери",
        tagLink: "#",
      },
      {
        tag: "межкомнатные",
        tagLink: "#",
      },
    ],
    linkToArticle: "/interior/Выбираем межкомнатные двери",
    text: [
      {
        attribute: "paragraph",
        content:
          "При выборе межкомнатной двери, помимо очевидных критериев: соотношение цена-качество, внешний вид, способ открывания; существуют не менее важные, такие как — экологичность, материалы изготовления, качественная звуко- и теплоизоляция.",
      },
      {
        attribute: "image",
        content: vybiraemmezhkom1,
      },
      {
        attribute: "title",
        content: "Классификация межкомнатных дверей",
      },
      {
        attribute: "paragraph",
        content: "По материалу конструкции:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Дерево. Отлично подходит для жилых помещений, благодаря высокой экологичности и натуральности. В продаже имеются, как эксклюзивные варианты из ценных пород, так и более дешевые - хвойные варианты. Существенный недостаток, о котором стоит сказать, это непереносимость повышенной влажности и колебаний температуры в помещении.",
          },
          {
            item: "ДСП. Качественно обработанная дверь из ДСП, вполне может заменить деревянную. К преимуществам относится — низкая стоимость, а недостатки такие же, как у деревянной.",
          },
          {
            item: "МДФ. Более популярны, чем модели из ДСП, из-за лучшего качества материала и долговечности.",
          },
          {
            item: "Пластик. Подойдет для отделки нежилых помещений, с высокими требованиями к влагостойкости.",
          },
          {
            item: "Стекло. Отлично впишутся в современный стиль интерьера.",
          },
        ],
      },
      {
        attribute: "paragraph",
        content: "По конструктивным особенностям:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Глухие. Обеспечивают хорошую изоляцию. Подходят для ванн, спален и кладовок.",
          },
          {
            item: "Со вставками. В качестве вставок применяется стекло или прозрачный пластик. Позволяют визуально расширить пространство, придают неповторимую атмосферу вашему дому.",
          },
        ],
      },
      {
        attribute: "paragraph",
        content: "По способу открывания:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Распашные. Самый распространенный тип — открываются в одну сторону, делятся на «правые» и на «левые» - это стоит учесть при выборе.",
          },
          {
            item: "Раздвижные. Или по-другому двери-купе, подойдут для небольших квартир и помещений. Более надежные модели имеют и верхнюю и нижнюю рельсу.",
          },
          {
            item: "Складные. Принцип действия схож с предыдущей моделью — панели, соединенные петлями, сдвигаются по направляющим рельсам. Может фиксироваться в одном положении.",
          },
          {
            item: "Радиусные. Самая оригинальная, но и самая дорогостоящая конструкция. Может иметь разные формы: выпуклая, вогнутая, комбинированная. Открываются и закрываются радиусные двери, также как и двери-купе.",
          },
          {
            item: "Маятниковые. Открываются в обе стороны. Применяются в служебных, производственных и общественных помещениях, редко в частных квартирах.",
          },
        ],
      },
      {
        attribute: "image",
        content: vybiraemmezhkom2,
      },
      {
        attribute: "paragraph",
        content:
          "Определившись с типом дверей, необходимо произвести замеры дверных проемов, а также правильно рассчитать гармоничное сочетание способа открывания — все двери должны открываться в одну сторону. При покупке следует особое внимание уделить экологичности и безопасности материала, качеству лако-красочного покрытия. Все детали должны быть хорошо подогнаны и закреплены.",
      },
    ],
  },
  // ARTICLE 3 END

  // ARTICLE 4 START
  {
    id: "Виниловая плитка",
    img: mainInteriorSidebar3,
    pretitle: "Интерьер",
    title: "Виниловая плитка",
    tagString: "интерьер отделка пол виниловая плитка",
    tags: [
      {
        tag: "интерьер",
        tagLink: "#",
      },
      {
        tag: "отделка",
        tagLink: "#",
      },
      {
        tag: "пол",
        tagLink: "#",
      },
      {
        tag: "виниловая",
        tagLink: "#",
      },
      {
        tag: "плитка",
        tagLink: "#",
      },
    ],
    linkToArticle: "/interior/Виниловая плитка",
    text: [
      {
        attribute: "paragraph",
        content:
          "Виниловая плитка относительно новый материал, предназначенный для отделки помещений. Как и все синтетические полимерные материалы — он выгоднее более дорогих натуральных аналогов. Помимо невысокой стоимости, виниловая плитка обладает целым рядом достоинств, выгодно выделяющих ее на фоне других напольных покрытий.",
      },
      {
        attribute: "image",
        content: vinilovayaplitka1,
      },
      {
        attribute: "title",
        content: "Классификация виниловой плитки",
      },
      {
        attribute: "paragraph",
        content:
          "Виниловая плитка состоит из спрессованных винила, смол, пластификаторов, инертных наполнителей и стабилизаторов. Обладает антибактериальными свойствами, не впитывает воду.",
      },
      {
        attribute: "paragraph",
        content:
          "Кварцвиниловая плитка обладает высоким эксплуатационным ресурсом благодаря содержанию природного кварца. Она не подвержена негативному воздействию влаги, химических кислот, солнечному свету. Из-за особой прочности, находит применение в отделке общественных и служебных помещений.",
      },
      {
        attribute: "image",
        content: vinilovayaplitka2,
      },
      {
        attribute: "paragraph",
        content: "Преимущества:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Прочность. Неплохо справляется с нагрузками, устойчива к истиранию и царапинам.",
          },
          {
            item: "Долговечность. Минимальный срок службы — 10 лет.",
          },
          {
            item: "Влагонепроницаемость. Плитка может быть использована для отделки помещений с высокой влажностью.",
          },
          {
            item: "Эстетичность. Большой ассортимент узоров и рисунков, имитирующих различные, в том числе природные, материалы, позволяет применять плитку в любом интерьере.",
          },
          {
            item: "Гигиеничность. Не причиняет вреда здоровью, легко моется и не впитывает запахи.",
          },
          {
            item: "Простота монтажа. Виниловые плитки имеют удобные размеры, позволяющие легко их устанавливать и при необходимости заменять один или несколько поврежденных элементов.",
          },
        ],
      },
      {
        attribute: "image",
        content: vinilovayaplitka3,
      },
      {
        attribute: "paragraph",
        content: "Недостатки:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Вмятины. Многослойность материала, где не все слои способны выдерживать длительные высокие нагрузки, не позволяет считать виниловые плитки — высокопрочным материалом.",
          },
          {
            item: "Выгорание рисунка. Не покрытые специальной пленкой, защищающей от ультрафиолетового излучения, плитки быстро выгорают на солнце.",
          },
          {
            item: "Нарушение микроклимата. Несмотря на безвредность для здоровья человека и животных, тем не менее пол покрытый синтетическим материалом, неблагоприятно влияет на микроклимат помещения.",
          },
        ],
      },
    ],
  },
  // ARTICLE 4 END

  // ARTICLE 5 START
  {
    id: "Регулировка пластиковых окон",
    img: regulirovkaOkon1,
    pretitle: "Интерьер",
    title: "Регулировка пластиковых окон «зима/лето»",
    tagString: "интерьер пластиковые окна регулировка зима лето",
    tags: [
      {
        tag: "интерьер",
        tagLink: "#",
      },
      {
        tag: "пластиковые",
        tagLink: "#",
      },
      {
        tag: "окна",
        tagLink: "#",
      },
      {
        tag: "регулировка",
        tagLink: "#",
      },
      {
        tag: "плитка",
        tagLink: "#",
      },
      {
        tag: "зима",
        tagLink: "#",
      },
      {
        tag: "лето",
        tagLink: "#",
      },
    ],
    linkToArticle: "/interior/Регулировка пластиковых окон",
    text: [
      {
        attribute: "paragraph",
        content:
          "Наверняка многие из вас слышали про возможность регулировки пластиковых окон в положения «зима/лето». Если вас интересует насколько данная настройка может стать полезной или наоборот навредить конструкции окна, то эта статья специально для вас.",
      },
      {
        attribute: "image",
        content: regulirovkaOkon2,
      },
      {
        attribute: "paragraph",
        content:
          "Регулировка представляет собой поворот запорных цапф летом — в положение минимум, а зимой — максимум. Это влияет на общую герметичность, способность окон дышать.",
      },
      {
        attribute: "paragraph",
        content:
          "Теперь рассмотрим механизм работы цапф. Цапфы относятся к фурнитуре которая позволяет открывать, фиксировать створку в определённых положениях, закрывать окно. Таким образом регулировка представляет собой простое увеличение или уменьшение степени закрутки цапф в створку. От этого зависит насколько уплотнитель прижимается к оконной раме.",
      },
      {
        attribute: "paragraph",
        content: "Теперь ответим на главный вопрос — стоит это делать или нет?",
      },
      {
        attribute: "paragraph",
        content:
          "Чтобы дать объективный ответ необходимо хорошо представлять какие именно изменения произойдут в работе всей системы, после подобной регулировки.",
      },
      {
        attribute: "paragraph",
        content:
          "Во-первых при увеличении прижима возрастает нагрузка на уплотнитель, длительное максимально сжатое состояние при низких температурах и высокой влажности — приведёт к раннему его износу и необходимости замены уже через два-три года.",
      },
      {
        attribute: "paragraph",
        content:
          "Во-вторых, самостоятельная регулировка приводит к дорогостоящей замене фурнитуры окна. Здесь всё просто - «заводская» настройка обеспечивает оптимальный прижим створки к раме, обеспечивая максимальный срок службы. Если вы её поменяете, то изменится работа всей системы. Так при закручивании цапф в положение «зима» - увеличивается трение между деталями, что повлияет на длительность эксплуатации.",
      },
      {
        attribute: "paragraph",
        content:
          "В-третьих, чрезмерно сжатый резиновый уплотнитель, деформирует окно. Профиль начинает выгибаться под действием разности давления: там где расположены зажимные цапфы — давление сильнее чем там где их нет, из-за «сопротивления» уплотнителя, отжимающего створку обратно. Справиться с последствиями, поможет лишь замена всей конструкции.",
      },
      {
        attribute: "image",
        content: regulirovkaOkon3,
      },
      {
        attribute: "paragraph",
        content:
          "Вот теперь вы знаете достаточно и можете ответить на поставленный вопрос: стоит ли заниматься регулировкой окон самостоятельно? Как показывает практика необходимость регулировки запорных цапф может возникнуть не ранее чем через три-четыре года. В этом случае необходимо обратиться к специалисту.",
      },
    ],
  },
  // ARTICLE 5 END
];
